export default __webpack_public_path__ + "static/media/driver_licence.43b0fb83.svg";